import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "page",
  ref: "pageRef"
}
const _hoisted_2 = { class: "page_wrap" }
const _hoisted_3 = { class: "performance_tab" }
const _hoisted_4 = { class: "performance_table" }
const _hoisted_5 = { class: "performance_box" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "item_pic" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "item_content" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "tag" }
const _hoisted_12 = { class: "tag_label" }
const _hoisted_13 = { class: "tag_label" }
const _hoisted_14 = { class: "time" }
const _hoisted_15 = { style: {"display":"flex","justify-content":"center","margin-top":"40px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NPagination = _resolveComponent("NPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "page_top_bg" }, [
      _createElementVNode("img", { src: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741936098056/project_top_bg.png" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["tab_item", _ctx.tabIndex == 1 ? 'tab_active' : '']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleChangeTab(1)))
        }, " 造价业绩 ", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tab_item", _ctx.tabIndex == 2 ? 'tab_active' : '']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleChangeTab(2)))
        }, " 监理业绩 ", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tab_item", _ctx.tabIndex == 3 ? 'tab_active' : '']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleChangeTab(3)))
        }, " 招标代理业绩 ", 2)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.List, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "performance_item",
              key: index,
              onClick: ($event: any) => (_ctx.handleRouter(item))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: item.pic,
                  alt: ""
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(item.attr), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(item.money), 1)
                ]),
                _createElementVNode("div", _hoisted_14, _toDisplayString(item.time), 1)
              ])
            ], 8, _hoisted_6))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_NPagination, {
            page: _ctx.page,
            "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page) = $event)),
            "page-size": _ctx.pageSize,
            "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageSize) = $event)),
            "item-count": _ctx.total,
            "on-update:page": _ctx.handlePageChange
          }, null, 8, ["page", "page-size", "item-count", "on-update:page"])
        ])
      ])
    ])
  ], 512))
}